/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32FilterItemOutput
 */
export interface Int32FilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof Int32FilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Int32FilterItemOutput
     */
    value?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Int32FilterItemOutput
     */
    isEffective?: boolean;
}

export function Int32FilterItemOutputFromJSON(json: any): Int32FilterItemOutput {
    return Int32FilterItemOutputFromJSONTyped(json, false);
}

export function Int32FilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32FilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function Int32FilterItemOutputToJSON(value?: Int32FilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': value.value,
        'isEffective': value.isEffective,
    };
}


